// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2MPPi","info":"Note_info__3B4yI","note":"Note_note__3wBCZ","actions":"Note_actions__2e2Dq"};